module.exports = __webpack_public_path__ + "static/img/Aions_GZ_Mar_1.f7afc35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_GZ_Mar/Aions_GZ_Mar_1.png
// module id = Kboh
// module chunks = 19